/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Lastupdated1Inputs */

const id_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir diperbarui:`)
};

const ms_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kemas kini terakhir:`)
};

const da_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst opdateret:`)
};

const de_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt aktualisiert:`)
};

const en_us2_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated:`)
};

const es_es2_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const es_mx2_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última actualización:`)
};

const fil_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling na-update:`)
};

const fr_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière mise à jour :`)
};

const it_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo aggiornamento:`)
};

const hu_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó frissítés:`)
};

const nl_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst bijgewerkt:`)
};

const no_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist oppdatert:`)
};

const pl_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia aktualizacja:`)
};

const pt_br2_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const pt_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última atualização:`)
};

const ro_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima actualizare:`)
};

const fi_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi päivitetty:`)
};

const sv_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast uppdaterad:`)
};

const vi_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lần cuối:`)
};

const tr_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son güncelleme:`)
};

const cs_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední aktualizace:`)
};

const bg_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна актуализация:`)
};

const ru_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее обновление:`)
};

const uk_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Останнє оновлення:`)
};

const ar_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تحديث:`)
};

const hi_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम अपडेट:`)
};

const th_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อัปเดตล่าสุด:`)
};

const ja_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新：`)
};

const zh_cn2_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后更新：`)
};

const zh_hant1_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後更新：`)
};

const ko_notifications_lastupdated1 = /** @type {(inputs: Notifications_Lastupdated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 업데이트:`)
};

/**
* | output |
* | --- |
* | "Last updated:" |
*
* @param {Notifications_Lastupdated1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_lastupdated1 = /** @type {((inputs?: Notifications_Lastupdated1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Lastupdated1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_lastupdated1(inputs)
	if (locale === "ms") return ms_notifications_lastupdated1(inputs)
	if (locale === "da") return da_notifications_lastupdated1(inputs)
	if (locale === "de") return de_notifications_lastupdated1(inputs)
	if (locale === "en-US") return en_us2_notifications_lastupdated1(inputs)
	if (locale === "es-ES") return es_es2_notifications_lastupdated1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_lastupdated1(inputs)
	if (locale === "fil") return fil_notifications_lastupdated1(inputs)
	if (locale === "fr") return fr_notifications_lastupdated1(inputs)
	if (locale === "it") return it_notifications_lastupdated1(inputs)
	if (locale === "hu") return hu_notifications_lastupdated1(inputs)
	if (locale === "nl") return nl_notifications_lastupdated1(inputs)
	if (locale === "no") return no_notifications_lastupdated1(inputs)
	if (locale === "pl") return pl_notifications_lastupdated1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_lastupdated1(inputs)
	if (locale === "pt") return pt_notifications_lastupdated1(inputs)
	if (locale === "ro") return ro_notifications_lastupdated1(inputs)
	if (locale === "fi") return fi_notifications_lastupdated1(inputs)
	if (locale === "sv") return sv_notifications_lastupdated1(inputs)
	if (locale === "vi") return vi_notifications_lastupdated1(inputs)
	if (locale === "tr") return tr_notifications_lastupdated1(inputs)
	if (locale === "cs") return cs_notifications_lastupdated1(inputs)
	if (locale === "bg") return bg_notifications_lastupdated1(inputs)
	if (locale === "ru") return ru_notifications_lastupdated1(inputs)
	if (locale === "uk") return uk_notifications_lastupdated1(inputs)
	if (locale === "ar") return ar_notifications_lastupdated1(inputs)
	if (locale === "hi") return hi_notifications_lastupdated1(inputs)
	if (locale === "th") return th_notifications_lastupdated1(inputs)
	if (locale === "ja") return ja_notifications_lastupdated1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_lastupdated1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_lastupdated1(inputs)
	return ko_notifications_lastupdated1(inputs)
});
export { notifications_lastupdated1 as "notifications.lastUpdated" }